import React from "react";
import {useDispatch} from "react-redux";
import PaymentSuccessPopup from "../Payments/paymentSuccessPopup";
import "../Payments/payments.css";
import "./addcard.css";
import {CrossIcon} from "../../Components/Icons";
import CreditCardManualNmiFields from "../AdminDashboard/CreditCardManualNmiFields";
import CreditCardSwipeEntryNmi from "../AdminDashboard/CreditCardSwipeEntryNmi";
import {SAVE_TRANSACTION_SUCCESS} from "../../constants";

const AdminAddCardInfoNmi = (props) => {
    const dispatch = useDispatch();
    const {
        openModal,
        paymentMsg,
        onCloseModal,

        addEditSwipeMode,
        setAddEditSwipeMode,
        handleSwipeAddCardInfo,

        adminUser,
        payerUser,
        paymentType,
        handleInputChange,
        handleSubmit,
        isPaymentSaveDetails,
        setIsPaymentSaveDetails,
        isDefault,
        setIsDefault,
        transactionLoading,
        updatePaymentType,
        manual,
        showResult,

    } = props;

    return (
        <>
            <div className="cross-btn" onClick={() => {
                dispatch({type: SAVE_TRANSACTION_SUCCESS});
                setAddEditSwipeMode("");
                updatePaymentType("");
            }}>
                <CrossIcon/>
            </div>
            <div
                className="creditCard"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
            >
                <div className="sos-content edit-payment-header payment-inner-toggleable">
                    <div className="edit-card-info mb-5">
                        <h3>Add Payment Method</h3>
                        <button
                            type="button"
                            onClick={(e) => handleSwipeAddCardInfo(e)}
                            className="toggle-manual-swipe add-card-btn toggle-manual-swipe"
                        >
                            {addEditSwipeMode === "add" && "Use Card Reader"}
                            {addEditSwipeMode === "swipe" && "Manual Entry"}
                        </button>
                    </div>

                    {addEditSwipeMode === "add" &&
                        <CreditCardManualNmiFields
                            addEditSwipeMode={addEditSwipeMode}
                            buttonText={"Save Payment Information"}
                            paymentGateways={adminUser?.paymentGateways}
                            paymentType={paymentType}
                            handleInputChange={handleInputChange}
                            handleSubmit={handleSubmit}
                            isPaymentSaveDetails={isPaymentSaveDetails}
                            setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                            isDefault={isDefault}
                            setIsDefault={setIsDefault}
                            transactionLoading={transactionLoading}
                            forceDisableAndCheck={true}
                            manual={manual}
                            showResult={showResult}
                        />}

                    {addEditSwipeMode === "swipe" &&
                        <CreditCardSwipeEntryNmi
                            addEditSwipeMode={addEditSwipeMode}
                            buttonText={"Tap/Insert/Swipe to Save Card"}
                            paymentGateways={adminUser?.paymentGateways}
                            handleInputChange={handleInputChange}
                            handleSubmit={handleSubmit}
                            paymentType={paymentType}
                            isPaymentSaveDetails={isPaymentSaveDetails}
                            setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                            isDefault={isDefault}
                            setIsDefault={setIsDefault}
                            transactionLoading={transactionLoading}
                            payerUser={payerUser}
                            forceDisableAndCheck={true}
                    />}

                </div>
            </div>
            <PaymentSuccessPopup
                openModal={openModal}
                paymentMsg={paymentMsg}
                onCloseModal={onCloseModal}
            />
        </>
    );
};

export default AdminAddCardInfoNmi;
